module.exports = __webpack_public_path__ + "img/btn_first_esports.de962f0d.png";